import { useQuery } from 'react-query';
import { httpService } from '../../../services/http.service';
import { BASE_URL } from '../../../constants/endpoints';
import { useStore } from '../../../store';
import { IServerErrorResponse } from '../../../types';

interface IProps {
    businessId: string;
    businessType: string;
    onError: (errorMessage: string) => void
}

interface IResponse {
    clearDate: string;
}

export const useGetMissingDoc = ({ businessId, onError }: IProps) => {
  const { customerId } = useStore(state => state.user);
  const queryParams = new URLSearchParams();
  queryParams.append('businessId', businessId);
  return useQuery(
    'useGetMissingDoc',
    async () => {
      const res = await httpService.get(`${BASE_URL}/api/v1/user/${customerId}/missingBusinessDocEINLetter?${queryParams}`);
      return res.data as IResponse;
    },
    {
      cacheTime: 5,
      enabled: false,
      retry: 2,
      retryDelay: 1,
      refetchOnWindowFocus: false,
      onError: (error: IServerErrorResponse) => {
        onError(error.response.data?.errors?.[0].localizedMessage || 'Something went wrong');
      },
    },
  );
};
